import React, { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';

import { fetchAllAgreementTypesStarted } from './store';
import { AgreementTypeFamilyTree } from './AgreementTypeFamilyTree';
import { AgreementTypeRelationshipSelect } from './AgreementTypeRelationshipSelect';
import { useFetchStarted } from '../../../hooks/useFetchStarted';

export interface AgreementTypeRelationshipsRouteParams {
    agreementTypeId: string | undefined;
}

export const AgreementTypeRelationships: React.FC<RouteComponentProps<AgreementTypeRelationshipsRouteParams>> = ({ match: { params } }) => {

    useFetchStarted([fetchAllAgreementTypesStarted()]);

    const pageContent = useMemo(() => {
        switch (params.agreementTypeId) {
            case undefined:
                return <AgreementTypeRelationshipSelect />;
            default:
                return <AgreementTypeFamilyTree agreementTypeId={params.agreementTypeId} />;
        }
    }, [params]);

    return pageContent;
};
